import { Component, OnInit, Input, Renderer2, ElementRef, ViewChild } from '@angular/core';

const DOCUMENT = <any>document;

@Component({
    selector: 'app-fixed-scroll',
    templateUrl: './fixed-scroll.component.html',
    styleUrls: ['./fixed-scroll.component.scss']
})
export class FixedScrollComponent implements OnInit {
    private fixed = false;
    public scrollTop = '0';

    @Input() scrollTopInit = 63;
    @Input() fixedClass: string;
    @ViewChild('fixedScroll') element: ElementRef;

    constructor(
        private renderer: Renderer2
    ) { }

    public ngOnInit(): void {
        if ((this.element && !this.element.nativeElement) || this.scrollTopInit === null) {
            return;
        }

        const element = 'documentElement' in DOCUMENT ? DOCUMENT.documentElement : DOCUMENT.body;

        window.onscroll = () => {
            const scrollTop = element.scrollTop - this.scrollTopInit;
            if (scrollTop > 0) {
                if (!this.fixed) {
                    this.fixed = true;
                    this.renderer.addClass(this.element.nativeElement, 'fixed');
                }

                this.scrollTop = `${scrollTop}px`;
            } else {
                this.fixed = false;
                this.renderer.removeClass(this.element.nativeElement, 'fixed');
            }
        };
    }
}
